module.exports = __webpack_public_path__ + "static/img/img_cat_37.eb24e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_cat_37.png
// module id = 550
// module chunks = 1